var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointer = function SvgPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.044 3.631a.65.65 0 0 0-.683-.062.66.66 0 0 0-.361.587v10.938c0 .282.18.533.446.624s.56-.003.728-.23l2.628-3.527 2.571 5.176c.16.325.552.456.875.292a.655.655 0 0 0 .291-.88l-2.574-5.176h4.381a.655.655 0 0 0 .392-1.182zm.26 9.494V5.47l6.088 4.594H8.914c-.207 0-.4.098-.522.262z"
  })));
};
export default SvgPointer;